import Vue from 'vue'
import { API_URL } from '../../api'
import CountriesFilter from '../../filters/CountriesFilter';
const state = {
    countryCreate: {
        createdCountry: null,
        creatingCountry: false,
        createCountryStatus: null
    },
    countryUpdate: {
        updatedCountry: null,
        updatingCountry: false,
        updateCountryStatus: null
    },
    countryDelete: {
        deletingCountry: false,
        deleteCountryStatus: null
    },
    countrySearch: {
        countriesCount: null,
        countries: [],
        searchingCountries: false,
        searchCountryStatus: null
    },
}
const mutations = {
    ['SET_COUNTRY_CREATE'](state, change) {
        state.countryCreate = { ...state.countryCreate, ...change };
    },
    ['SET_COUNTRY_UPDATE'](state, change) {
        state.countryUpdate = { ...state.countryUpdate, ...change };
    },
    ['SET_COUNTRY_DELETE'](state, change) {
        state.countryDelete = { ...state.countryDelete, ...change };
    },
    ['SET_COUNTRY_SEARCH'](state, change) {
        state.countrySearch = { ...state.countrySearch, ...change };
    }
}
const actions = {
    createCountry: ({ commit }, payload) => {
        commit('SET_COUNTRY_CREATE', { createCountryStatus: null, createdCountry: null, creatingCountry: true })
        return Vue.http.post(API_URL + '/countries/create', payload).then(response => {
            commit('SET_COUNTRY_CREATE', { createCountryStatus: 'success', createdCountry: response.body.results.country });
        }).catch(response => {
            commit('SET_COUNTRY_CREATE', { createCountryStatus: 'failed' });
        }).finally(() => {
            commit('SET_COUNTRY_CREATE', { creatingCountry: false });
        });
    },
    updateCountry: ({ commit }, payload) => {
        commit('SET_COUNTRY_UPDATE', { updateCountryStatus: null, updatedCountry: null, updatingCountry: true })
        return Vue.http.post(API_URL + '/countries/update/' + payload.id, payload)
            .then(response => {
                commit('SET_COUNTRY_UPDATE', { updateCountryStatus: 'success', updatedCountry: response.body.results.country });
            })
            .catch(response => {
                commit('SET_COUNTRY_UPDATE', { updateCountryStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_COUNTRY_UPDATE', { updatingCountry: false });
            })
    },
    deleteCountry: ({ commit }, id) => {
        commit('SET_COUNTRY_DELETE', { deleteCountryStatus: null, deletedCountry: null, deletingCountry: true })
        return Vue.http.delete(API_URL + '/countries/delete/' + id).then(response => {
            commit('SET_COUNTRY_DELETE', { deleteCountryStatus: 'success' });
        }).catch(response => {
            commit('SET_COUNTRY_DELETE', { deleteCountryStatus: 'failed' });
        }).finally(() => {
            commit('SET_COUNTRY_DELETE', { deletingCountry: false });
        })
    },
    searchCountries: ({ commit }, payload = { filter: CountriesFilter(), resultMode: 'default' }) => {
        commit('SET_COUNTRY_SEARCH', { searchCountryStatus: null, searchCountry: null, searchingCountries: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/countries' + params).then(response => {
            commit('SET_COUNTRY_SEARCH', { searchCountryStatus: 'success', countries: response.body.results.countries });
        }).catch(response => {
            commit('SET_COUNTRY_SEARCH', { searchCountryStatus: 'failed' });
        }).finally(() => {
            commit('SET_COUNTRY_SEARCH', { searchingCountries: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/countryStore.js